export default __webpack_public_path__ + "static/media/supraSummary.1d17df77.jpg";